import React from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import CookiesWrapper from '../common/cookies-wrapper';
import { composeEnterHooksSeries } from '../common/routes-helper';
import constants from '../common/constants';
import registerConstants from '../app/main/register/constants/register-constants';

import App from '../App';
import Layout from '../app/main/layout/components/layout';

import Login from '../app/main/login/components/login';
import Register from '../app/main/register/components/register';
import ResetPassword from '../app/main/reset-password/components/reset-password';

import Dashboard from '../app/main/dashboard/components/dashboard';
import UserProfile from '../app/main/user-profile/components/user-profile';
import ChangePassword from '../app/main/user-profile/components/change-password';
import Withdrawals from '../app/main/withdrawals/components/withdrawals';
import PaymentHistory from '../app/main/payments/components/payment-history';
import Banners from '../app/main/banners/components/banners';
import Logos from '../app/main/logos/components/logos';
import Videos from '../app/main/videos/components/videos';
import Campaigns from '../app/main/campaigns/components/campaigns';
import Clients from '../app/main/clients/components/clients';
import LinkCreator from '../app/main/link-creator/components/link-creator';
// import CommissionPlans from '../app/main/commission-plans/components/commission-plans';
// import Sources from '../app/main/sources/components/sources';
// import Reports from '../app/main/reports/components/reports';
import Faq from '../app/main/faq/components/faq';
import PaymentMethods from '../app/main/payment-methods/components/payment-methods';
import B2B from '../app/main/b2b/components/b2b';
import CommissionScheme from '../app/main/commission-scheme/components/commission-scheme';
import RegisterType from '../app/main/register/components/register-type';
import Widgets from '../app/main/widgets/components/widgets';

const Routes = () => {
  /**
   * If user is not authenticated, send him to login page
   */
  const isAuthenticated = (nextState, replace) => {
    if (!CookiesWrapper.getCookie(constants.cookie_key_word)) {
      replace({ pathname: '/login' });
      return false;
    }

    return true;
  };

  const isApproved = (nextState, replace) => {
    const sessionTokens = CookiesWrapper.getCookie(constants.cookie_key_word);

    if (sessionTokens && sessionTokens.user_type && sessionTokens.user_bo_status) {
      if (
        (sessionTokens.user_type === registerConstants.user_types.ifs_type ||
          sessionTokens.user_type === registerConstants.user_types.affiliate ||
          sessionTokens.user_type === registerConstants.user_types.ib) &&
        sessionTokens.user_bo_status !== constants.bo_statuses.approved
      ) {
        replace({ pathname: '/app/dashboard' });
        return false;
      }
    }

    return true;
  };

  return (
    <Router history={browserHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={Login} />
        <Route path="/login" component={Login} />
        <Route path="/register" component={RegisterType} />
        <Route path="/register/:step" component={Register} />
        <Route path="/password/reset/:email/:code" component={ResetPassword} />
        <Route path="/app" component={Layout} onEnter={composeEnterHooksSeries(isAuthenticated)}>
          <Route path="dashboard" component={Dashboard} />
          <Route path="profile" component={UserProfile} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="profile/change-password" component={ChangePassword} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="withdrawals" component={Withdrawals} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="payment-history" component={PaymentHistory} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="banners" component={Banners} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="logos" component={Logos} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="videos" component={Videos} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="campaigns" component={Campaigns} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="clients" component={Clients} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="link-creator" component={LinkCreator} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="widgets" component={Widgets} onEnter={composeEnterHooksSeries(isApproved)} />
          {/* <Route path="commission-plans" component={CommissionPlans} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="sources" component={Sources} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="reports" component={Reports} onEnter={composeEnterHooksSeries(isApproved)} /> */}
          <Route path="faq" component={Faq} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="payment-methods" component={PaymentMethods} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="b2b" component={B2B} onEnter={composeEnterHooksSeries(isApproved)} />
          <Route path="commission-scheme" component={CommissionScheme} onEnter={composeEnterHooksSeries(isApproved)} />
        </Route>
      </Route>
    </Router>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/core/routes.js